import React from 'react';
import {UserContext} from '../../../utils/usercontext';
import {postApi, putApi, deleteApi} from '../../../utils/functions';

import moment from 'moment';
import momenttz from 'moment-timezone';
import dayjs from 'dayjs';
import { DateTime } from 'luxon';
import { DatePicker } from "antd";
//import "antd/dist/antd.css";
import TimePicker from "rc-time-picker";
import 'rc-time-picker/assets/index.css';
//import BBCode from '../../components/bbcode/bbcode';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import '../fontawesome/fontawesome';
//import Genres from '../genres/genres';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Dropdown from 'react-bootstrap/Dropdown';

import './schedule.css';

class ScheduleEdit extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
      show: this.props.show!==false ? true : false,
			service: this.props.service,

			djs: [],
			replays: [],
			recordings: false,
			defaultgenres: '',
			isOrganiser: this.props.isOrganiser,

			dj: this.props.schedule.uid,
			id: this.props.schedule.id,
			title: this.props.schedule.djtitle,
			//description: this.props.schedule.description,
			date: dayjs(this.props.schedule.start),
			start: new Date(this.props.schedule.start),
			end: new Date(this.props.schedule.end),
			syndicate: this.props.schedule.syndicate,
			
			genres: {
        show: false, // to show selection
        value: '', // searching
        fulllist: [], // full list of genres
        picker: {}, // selected genres
        picked: this.props.schedule.genres
      },

			recurring: this.props.schedule.recurring===1?true:false,
			cancelled: this.props.schedule.cancelled===1?true:false,
			overlap:{},

			audioport: false,
			facebook_time: 0,

			err_title: '',
			err_start: '',
			err_end: '',
			err_else: '',

    };
		//consoleLog(this.state);

		this.close = this.close.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.submitEvent = this.submitEvent.bind(this);

		this.setDate = this.setDate.bind(this);
		this.setStart = this.setStart.bind(this);
		this.setEnd = this.setEnd.bind(this);

		this.selectGenre = this.selectGenre.bind(this);
		this.removeGenre = this.removeGenre.bind(this);
		this.scheduleSwitch = this.scheduleSwitch.bind(this);
		this.scheduleDelete = this.scheduleDelete.bind(this);
		this.editEvent = this.editEvent.bind(this);
  };

  //loading:any = React.createRef();
  
  async componentDidMount() {

		var params = new URLSearchParams();
		params.append('service', this.props.service);
		const x = await postApi(`${this.context.worker[this.props.service]}/v3/service/prepare`, params);
		//consoleLog(x.data);
		if( x.status === 200 ) {

			let _dj = -1;
			for( let djs in x.data.djs ) {
				if( x.data.djs[djs].id === this.state.dj ) {
					_dj = parseInt(djs);
				}
			}

			//const user = this.context;
			let defaultgenres = [];//(user.user.admin.part_admin_access||this.state.isOrganiser)? this.props.genres : x.data.defaultgenres.length > 0 ? x.data.defaultgenres : this.props.genres;
			
			let genres = this.state.genres;
			genres.fulllist = x.data.genres;

			this.setState({djs: x.data.djs, replays: x.data.replays, dj: _dj, genres, defaultgenres, audioport: x.data.audioport});
		} else if( x.status === 220 ) {
			this.setState({access: false});
		} else {

		}

		var d = new Date();
		d.setUTCHours(20);
		d.setMinutes(0);
		d.setSeconds(0);
		this.setState({facebook_time: Math.floor(d.getTime()/1000)});

	}

	close() {
		this.setState({ show: false }, () => this.props.close() );
	}


	handleChange(event) {
		var item = event.target.value;
		//consoleLog(event.target.name, event.target.checked);
		if( event.target.name === "dj" ) this.setState({dj: item});
		if( event.target.name === "title" ) this.setState({title: item});
		//if( event.target.name === "description" ) this.setState({description: item});
		if( event.target.name === "genre" ) {
      let genres = this.state.genres;
      genres.value = item;
      let _new = {};
      if( item.length >= 4 ) {
        genres.show = true;
        for( let i in this.state.genres.fulllist ) {
          for( let j in this.state.genres.fulllist[i] ) {
            let search = new RegExp(`(${item.replace(' ','|')})`,"gi");
            if( this.state.genres.fulllist[i][j].match(search) != null ) {
              if( !_new[i] ) _new[i] = [];
              _new[i].push(this.state.genres.fulllist[i][j]);
            }
          }
        }
      } else genres.show = false;
      genres.picker = _new;
      this.setState({genres});
    }
		if( event.target.name === "recurring" ) this.setState({recurring: event.target.checked});
		if( event.target.name === "cancelled" ) this.setState({cancelled: event.target.checked});
	}

	

	setDate(e) {
		let date = this.state.date;
		if( e ) {
			date = e._d || e['$d'];
		} else {
			date = 0;
		}
		this.setState({date});
	}

	setStart(e) {
		this.setState({start: e._d});
	}

	setEnd(e) {
		this.setState({end: e._d});
	}

	async submitEvent(e) {
		if( e ) e.preventDefault();

		let params = new URLSearchParams();
		params.append('service', this.state.service);
		params.append('isOrganiser', this.state.isOrganiser);
		//params.append('id', this.state.id);
		if(this.state.dj>=0) params.append('dj', this.state.djs[this.state.dj].id);
		params.append('title', this.state.title);
		//params.append('description', this.state.description);

		let c = new Date(this.state.date);
		let d = new Date(this.state.start);
		let f = new Date(this.state.end);
		try{
				
				c.setHours(0);
				c.setMinutes(0);
				c.setSeconds(0);
				//params.append('date', Math.floor( c.getTime() / 1000 ));
		} catch(error) {
			this.setState({err_start: '** Check Entry Date and Time'});
			return;
		}

		try{
				d.setUTCFullYear(c.getFullYear());
				d.setUTCMonth(c.getUTCMonth());
				d.setUTCDate(c.getUTCDate());
				if( d.getTime() < c.getTime() ) d.setUTCDate(c.getUTCDate()+1);
				//d.setHours(0);
				//d.setMinutes(0);
				d.setSeconds(0);
				params.append('start', Math.floor( d.getTime() / 1000 ));
		} catch(error) {
			this.setState({err_start: '** Check Entry Date and Time'});
			return;
		}

		try{
				f.setUTCFullYear(d.getFullYear());
				f.setUTCMonth(d.getUTCMonth());
				f.setUTCDate(d.getUTCDate());
				if( f.getTime() < d.getTime() ) f.setUTCDate(d.getUTCDate()+1);
				//f.setHours(0);
				//f.setMinutes(0);
				f.setSeconds(0);
				params.append('end', Math.floor( f.getTime() / 1000 ));
		} catch(error) {
			this.setState({err_start: '** Check Entry Date and Time'});
			return;
		}
		
		params.append('genres', this.state.genres.picked.join(','));
		params.append('recurring', (this.state.recurring === true || this.state.recurring === 1) ? 1: 0);
		params.append('cancelled', (this.state.cancelled === true || this.state.cancelled === 1) ? 1: 0);
		params.append('showname', this.props.showname);
		params.append('syndicate', this.state.syndicate);
		
		const x = await putApi(`${this.context.worker[this.props.service]}/v3/service/schedule/${this.state.id}`, params);
		if( x.status === 200 ) {
			this.close();
		} else {
			if(x.status===213) {
				this.setState({err_else: `Error: Schedule booking overlaps with another booking. Please check your entry times`});
				this.setState({overlap: x.data});
			} else {
				this.setState({err_else: `Error: ${x.data}`});
			}
		}
	}

	DJDate() {
		let timezone_non = new Date().getTimezoneOffset()*-1;//.toLocaleString("en-US", { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone });
		let timezone_uk = momenttz(timezone_non).tz("Europe/London")._offset;
		//let starttime = this.state.starttime.getTime()


		let c = new Date(this.state.startdate);
		try{
				c.setHours(this.state.starttime.getHours());
				c.setMinutes(this.state.starttime.getMinutes());
				c.setSeconds(0);
		 } catch(error) {}
		let d = new Date(this.state.enddate);
		try{
				d.setHours(this.state.endtime.getHours());
				d.setMinutes(this.state.endtime.getMinutes());
				d.setSeconds(0);
		 } catch(error) {}
		return (
			<>
				{moment(this.state.starttime).format("HH:mm")} - {moment(this.state.endtime).format("HH:mm")}
				{timezone_non!==timezone_uk &&
					<>
						<br />
						<small>({moment((Math.floor(c/1000)+(timezone_uk-timezone_non)*60)*1000).format("HH:mm")} - {moment((Math.floor(d/1000)+(timezone_uk-timezone_non)*60)*1000).format("HH:mm")} UK)</small>
					</>
				}
			</>
		)
	}
	DJTime() {
		try{ 
			const user = this.context;

			var str = "";
			if( user.user.user.rank === 4 ) {
				str = this.state.title?this.state.title:user.user.user.title?user.user.user.title:user.user.user.username;
			} else {
				if( this.state.title !== '' ) {
					str = this.state.title;
				} else {
					if( this.state.dj !== 0 ) {
						str = this.state.djs[this.state.dj].title?this.state.djs[this.state.dj].title:this.state.djs[this.state.dj].username;
					}
				}
			}
			//if( this.state.description ) str += " - " + this.state.description;
			
			return str; //"DJ Jim Bob ~ 18:00 - 20:00";
		} catch(error) {
			return "";
		}
	}


	selectGenre(genre) {
    let genres = this.state.genres;
    genres.show = false;
    genres.value = '';
		for( let i in genres.picker ) if( genre === genres.picker[i] ) return;
		genres.picked.push(genre);
		this.setState({genres});
	}

	removeGenre(genre) {
		let genres = this.state.genres;
		for( let i in genres.picked ) if( genre === genres.picked[i] ) genres.picked.splice( i, 1 );
		this.setState({genres});
	}
	
	async scheduleSwitch(e) {
		if(window.confirm("Are you sure you wish to switch this schedule entry?")) {
			var params = new URLSearchParams();
			params.append('id', e);
			await putApi('/api/v2/schedule/switch', params);
			this.close();
		}
	}

	async scheduleDelete(e) {
		if(window.confirm("Are you sure you wish to delete this schedule entry?")) {
			var params = new URLSearchParams();
			params.append('service', this.state.service);
			params.append('id', e);
			await deleteApi(`${this.context.worker[this.props.service]}/v3/service/schedule/${this.state.id}`, params);
			this.close();
		}
	}

	async editEvent(syndicate) {
		//console.log(syndicate);
		this.setState({syndicate},()=>{
			this.submitEvent();
		});
	}

	render() {
		const user = this.context;
		//let timezone_non = new Date().getTimezoneOffset()*-1;
		//let timezone_uk = momenttz(timezone_non).tz("Europe/London")._offset;

		let rank = 0;
		let show = false;

		const djs = 
      this.state.djs.map((e,i) => {
				if( this.state.djs[i].id_level !== rank ) {
					show = true;
					rank = this.state.djs[i].id_level;
				} else {
					show = false;
				}
        return (
					<React.Fragment key={i}>
						{show &&
							<option value="-1" disabled={true}>
								{rank>=80 &&<>The Owner</>}
								{rank>=70 && rank<80 &&<>Technical Staff</>}
								{rank>=60 && rank<70 &&<>Support Staff</>}
								{rank>=50 && rank<60 &&<></>}
								{rank>=40 && rank<50 &&<>Radio Owner</>}
								{rank>=30 && rank<40 &&<>Radio Admin</>}
								{rank>=20 && rank<30 &&<>Radio DJs</>}
							</option>
						}
						<option value={i}>
							{this.state.djs[i].title?
								<>&nbsp;&nbsp;&nbsp;&nbsp;{this.state.djs[i].title} ({this.state.djs[i].username})</>
							:
								<>&nbsp;&nbsp;&nbsp;&nbsp;{this.state.djs[i].username}</>
							}
						</option>
					</React.Fragment>
        )
      })
			const genrelist = Object.keys(this.state.genres.picker).map((e,i) => {
				return (
					<React.Fragment key={i}>
						<div><p>{e}</p></div>
						<div style={{marginLeft: -5}}>
							{(() => {
								return Object.keys(this.state.genres.picker[e]).map((f,j) => {
									return (
										<Button key={j} className="btn btn-sm btn-info my-1 me-2" onClick={()=>this.selectGenre(this.state.genres.picker[e][f])}>{this.state.genres.picker[e][f]}</Button>
									)
								})
							})()}
						</div>
						<div style={{clear: 'both', paddingBottom: 10}}></div>
					</React.Fragment>
				)
			})
			const genrepicked = this.state.genres.picked.map((e,i) => {
				return (
					<Button key={i} size="sm" className="btn btn-teal-gradient btn-wave waves-effect waves-light">{e}
						<OverlayTrigger placement="top" key="overlay-5" overlay={<Tooltip id="tooltip5">Remove Genre</Tooltip>}>
							<span className="badge ms-2 bg-white text-primary" onClick={()=>this.removeGenre(e)}><FontAwesomeIcon icon="xmark" /></span>
						</OverlayTrigger>
						
					</Button>
				)
			})
			const replays = this.state.replays.map((e,i) => {
				let date = new Date(null);
				date.setSeconds(e.length); // specify value for SECONDS here
				let result = date.toISOString().substr(11, 8);
				return (
					<Dropdown.Item key={i} eventKey={e.id} onClick={()=>this.editEvent(e.id)}>
						<Row>
							<div style={{width: 138}}>
								<img src={e.png} width={124} style={{borderRadius: 5}} alt="Video Png" />
							</div>
							<Col style={{paddingTop: 4}}>
								{e.showname}<br />
								{e.title ?
									<>
										{e.title} - ({e.username})
									</>
								:
									<>
										{e.username}
									</>
								}<br />
								Running Time: {result}
							</Col>
						</Row>
					</Dropdown.Item>
				)
			});
		return (
			<Modal show={this.state.show} onHide={this.close} backdrop="static" keyboard={false} size="xl" centered>
				<Modal.Header closeButton className="">
					<Modal.Title>Edit Schedule Entry</Modal.Title>
				</Modal.Header>
				<Modal.Body className="">
					<Row>
						<Col xs={12}>
							{this.state.syndicate === 0 ?
								<Form onSubmit={this.submitEvent}>
								
									{user.user.admin &&
										<>
											<div className="form-group row pt-1 pb-0 mb-1">
												<label htmlFor="dj" className="col-sm-4 col-form-label col-form-label-sm ps-4 text-vcenter">
													<strong>Select DJ</strong><br />
												</label>
												<div className="col-md-6 mt-2">
													<Form.Control as="select" name="dj" id="dj" value={this.state.dj} onChange={this.handleChange}>
														{djs}
													</Form.Control>
												</div>
											</div>
											<hr />
										</>
									}

									
									<div className="form-group row pt-1 pb-0 mb-1">
										<label htmlFor="title" className="col-sm-4 col-form-label col-form-label-sm ps-4 text-vcenter">
											<strong>Set Title</strong><br />
										</label>
										<div className="col-md-6 p-1">
											<Form.Control type="text" name="title" id="title" value={this.state.title} onChange={this.handleChange} className="form-control-sm" placeholder="title" />
										</div>
									</div>
									<Col xs={12} className="ps-2">
										<small>
											* <b>Optional</b>, set this if you wish to use a specific name for your set or for B2B and guest sets
										</small>
									</Col>
									
									<hr />

									<div className="form-group row pt-1 pb-0 mb-1">
										<label className="col-sm-4 col-form-label col-form-label-sm ps-4 text-vcenter">
											<strong>Date and Time</strong><br />
											{/*<small>(Your Local Timezone)</small><br />*/}
											{/*<strong className="schedule_error">{this.state.err_start}</strong>*/}
										</label>
										<div className="col-md-2 mt-2">
											Date
											<DatePicker defaultValue={this.state.date} onChange={this.setDate} getPopupContainer={(triggerNode)=>{return triggerNode.parentNode;}} onFocus={e => e.target.blur()} />
											{/*<DatePicker defaultValue={dayjs(this.state.startdate)} onChange={this.setStartDate} getPopupContainer={(triggerNode)=>{return triggerNode.parentNode;}} onFocus={e => e.target.blur()} />*/}
										</div>
										<div className="col-md-2 mt-2">
											Start
											<TimePicker
												placeholder="Select Time"
												use12Hours={false}
												showSecond={false}
												focusOnOpen={true}
												minuteStep={15}
												format="HH:mm"
												defaultValue={moment(this.state.start)}
												onChange={(e) => this.setStart(e)}
												popupClassName="text-oppisite"
												onFocus={e => e.target.blur()}
											/>
										</div>
										<div className="col-md-2 mt-2">
											End
											<TimePicker
												placeholder="Select Time"
												use12Hours={false}
												showSecond={false}
												focusOnOpen={true}
												minuteStep={15}
												format="HH:mm"
												defaultValue={moment(this.state.end)}
												onChange={(e) => this.setEnd(e)}
												popupClassName="text-oppisite"
												onFocus={e => e.target.blur()}
											/>
										</div>
									</div>
									

									<hr />

									{/*<div className="form-group row pt-1 pb-0 mb-1">
										<label className="col-sm-4 col-form-label col-form-label-sm ps-4 text-vcenter">
											<strong>End Datetime</strong><br />
											<small>(Your Local Timezone)</small><br />
											<strong className="schedule_error">{this.state.err_end}</strong>
										</label>
										<div className="col-md-2 mt-2">
											<DatePicker defaultValue={dayjs(this.state.endtime)} onChange={this.setEndDate} getPopupContainer={(triggerNode)=>{return triggerNode.parentNode;}} onFocus={e => e.target.blur()} />
										</div>
										
									</div>*/}

									<div className="form-group row pt-1 pb-0 mb-1">
										<label htmlFor="genres" className="col-sm-4 col-form-label col-form-label-sm ps-4 text-vcenter">
											<strong>Genres</strong><br />
											{/*<small>(Optional)</small>*/}
										</label>
										<div className="col-md-6 mt-2 genres" style={{position: 'relative'}}>
											<Form.Control type="text" name="genre" id="genre" value={this.state.genres.value} onChange={this.handleChange} className="form-control-sm" placeholder="Search Genres">
												
											</Form.Control>
											{this.state.genres.show === true &&
												<div className="card card-body p-1" style={{position: 'absolute', top: 33, width: '96%', fontSize: 14, maxHeight: 245, overflowY: 'scroll', zIndex:5}}>
													<div className="blockquote custom-blockquote info mb-0" style={{padding: 10}}>
														{genrelist}
													</div>
												</div>
											}
											
											{/*user.user.admin.part_admin_access && this.state.djs[this.state.dj] && this.state.djs[this.state.dj].defaultgenres.length > 0 && 
												<small>
													Leave blank for genres: {this.state.djs[this.state.dj].defaultgenres.replaceAll(',',', ')}<br />
												</small>
										*/}
											<div className="genrepick-box">
												{genrepicked}
											</div>
										</div>
									</div>
									<Col xs={12} className="ps-2">
										<small>
											* <b>Optional</b>, set this if you wish to assign genres to your set<br />
											* You can assign default genres via your profile
										</small>
									</Col>
									<hr />

									{!this.state.isOrganiser && !user.user.admin.part_admin_access && 
										<div className="form-group row pb-0 mb-1">
											<label htmlFor="recurring" className="col-sm-4 col-form-label col-form-label-sm ps-4 text-vcenter">
											</label>
											<div className="col">
												{this.state.defaultgenres.length > 0 &&
													<p>
														Leave blank for genres: #{this.state.defaultgenres.replaceAll(',',', #')}
													</p>
												}
											</div>
										</div>
									}

									{(this.state.isOrganiser || user.user.admin.part_admin_access ) && this.state.djs[this.state.dj] &&
										<div className="form-group row pb-0 mb-1">
											<label htmlFor="recurring" className="col-sm-4 col-form-label col-form-label-sm ps-4 text-vcenter">
											</label>
											<div className="col">
												{this.state.djs[this.state.dj].defaultgenres.length > 0 ?
													<p>
														Leave blank for genres: #{this.state.djs[this.state.dj].defaultgenres.replaceAll(',',', #')}
													</p>
												:
													<>
														{this.state.defaultgenres.length > 0 && 
															<p>
																Leave blank for genres: #{this.state.defaultgenres.replaceAll(',',', #')}
															</p>
														}
													</>
												}
											</div>
										</div>
									}

									<div className="form-group row pt-1 pb-0 mb-1">
										<label htmlFor="recurring" className="col-sm-4 col-form-label col-form-label-sm ps-4">
											<strong>Recurring</strong><br />
											{/*<small>(Repeat event on organiser basis)</small>*/}
										</label>
										<div className="col-md-6 mt-2">
											{/*<Form.Check type={"checkbox"} name="recurring" id="recurring" checked={this.state.recurring} onChange={this.handleChange} />
											<div className="form-check form-switch">
											<input className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" />
											</div>*/}
											<div className={`toggle mb-3 ${this.state.recurring===true?'on':''}`} onClick={()=>this.handleChange({target: { name: 'recurring', item: 'on', checked: !this.state.recurring}})}>
												<span></span>
											</div>
											{/*<Form.Check type={"checkbox"} name="recurring" id="recurring" checked={this.state.recurring} onChange={this.handleChange} disabled={this.state.fortnightly?this.state.fortnightly:this.state.starttime<Date.now()?true:false} />*/}
										</div>
									</div>
									<Col xs={12} className="ps-2">
										<small>
											* <b>Recurring</b>, Automatically re-book your sets on week to week basis. 
										</small>
									</Col>

									
									<div className="form-group row pt-1 pb-0 mb-1">
										<label htmlFor="cancelled" className="col-sm-4 col-form-label col-form-label-sm ps-4">
											<strong>Cancel</strong><br />
											{(parseInt(this.state.recurring)===1||this.state.recurring===true) ?
												<small>{/*(Cancel only this recurring show)*/}</small>
											:
												<small></small>
											}
										</label>
										<div className="col-md-6 mt-2">
											{/*<Form.Control type="checkbox" name="cancelled" id="cancelled" onChange={this.handleChange} className="form-control-sm"/>*/}
											{/*<Form.Check type={"checkbox"} name="cancelled" id="cancelled" checked={this.state.cancelled} onChange={this.handleChange} />*/}
											<div className={`toggle mb-3 ${this.state.cancelled===true?'on':''}`} onClick={()=>this.handleChange({target: { name: 'cancelled', item: 'on', checked: !this.state.cancelled}})}>
												<span></span>
											</div>
										</div>
									</div>
									<Col xs={12} className="ps-2">
										{(parseInt(this.state.recurring)===1||this.state.recurring===true) &&
											<small>
												* <b>Cancel</b>, Cancel only this one recurring show and resume on the following booking.
											</small>
										}
									</Col>
									

									<div className="form-group row pt-1 pb-0 mb-1">
										<label className="col-sm-4 col-form-label col-form-label-sm ps-4"></label>
										<div className="col mt-2">
											<strong className="schedule_error">{this.state.err_else}</strong>
										</div>
									</div>


									{Object.values(this.state.overlap).length > 0 &&
										<div className="form-group row pt-1 pb-0 mb-1">
											<label className="col-sm-4 col-form-label col-form-label-sm ps-4"></label>
											<div className="col mt-2">
												<Row>
													<div style={{width:80}}><img src={`https://rhousemusic.com${this.state.overlap.avatar}`} width="60" alt="Overlap Avatar" /></div>
													<Col>{this.state.overlap.username}<br />
														{moment(this.state.overlap.start*1000).format("dddd Do MMMM")} ~
														{moment(this.state.overlap.start*1000).format("HH:mm")} -
														{moment(this.state.overlap.end*1000).format("HH:mm")}
														({DateTime.local().toFormat('ZZZZ')})
													</Col>
												</Row>
											</div>
										</div>
									}

								</Form>
							:
								<>{replays}</>
							}
						</Col>
					</Row>
				</Modal.Body>
				<Modal.Footer className="">
					{user.user.admin &&
						<Button className="button-admin" onClick={()=>this.scheduleDelete(this.props.schedule.id)}><FontAwesomeIcon icon="trash" />&nbsp;Delete</Button>
					}
					{this.state.syndicate > 0 &&
						<Button className="button-admin" onClick={()=>this.editEvent(0)}>&nbsp;Revert to Live</Button>
					}
					<Button onClick={this.close}>
						Close
					</Button>
					{//this.state.access&&
						<Button onClick={this.submitEvent}>Save Changes</Button>
					}
				</Modal.Footer>
			</Modal>
		);
	}
}

export default ScheduleEdit;